import { render } from "./ActionModal.vue?vue&type=template&id=095dfc88&scoped=true"
import script from "./ActionModal.vue?vue&type=script&lang=ts"
export * from "./ActionModal.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-095dfc88"

export default script